import { gsap } from 'gsap';

const SELECTOR = {
  HTML: document.documentElement,
  LOADER: document.querySelector('[data-loader]'),
  BG: document.querySelector('[data-loader-bg]'),
  BODY: document.querySelector('[data-loader-body]'),
  COPY: document.querySelector('[data-loader-copy]'),
  LOGO: document.querySelector('.header-svg'),
}

const CLASSES = {
  LOCKED: 'is-locked',
  LOADED: 'is-loaded',
}

export default class Loader {
  constructor() {
    if(!SELECTOR.LOADER) return;

    SELECTOR.HTML.classList.add(CLASSES.LOCKED);

    const time = new Date().getTime();

    window.addEventListener('load', () => {
      const now = new Date().getTime();

      const loadTime = 3200

      if (now - time <= 1800) {
        setTimeout(this.loaded, loadTime - (now - time));
        return;
      } else {
        this.loaded();
      }

    });

    this.openingSVG();
  }

  openingSVG() {
    const tl = gsap.timeline({
      defaults: {
        ease: 'none'
      }
    });

    tl.to(
      SELECTOR.BG, {
        opacity: 1,
        duration: 0.3,
      })
      .to(
        SELECTOR.BODY, {
          opacity: 1,
          duration: 0.1,
        }, '-=0.5'
      )
      .fromTo(
        SELECTOR.LOGO, {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 2,
        },
      )
      .to(
        SELECTOR.LOGO, {
          opacity: 0,
          duration: 1,
          ease: "power2.out"
        }
      )
      .to(
        SELECTOR.LOADER, {
          opacity: 0,
          duration: 2.5,
      }, "-=1"
    );
  }

  opening() {
    const str = SELECTOR.COPY.innerHTML
    let text = ''

    str.split(/(?=[^>]*(?:<|$))/).forEach(char => {
      if (char.match(/[&<>'"]/)) {
        text += `${ char }`
        SELECTOR.COPY.innerHTML = text
      } else {
        text += `<span>${ char }</span>`
        SELECTOR.COPY.innerHTML = text
      }
      SELECTOR.COPY.spans = [...SELECTOR.COPY.querySelectorAll('span')];
    });

    const tl = gsap.timeline({
      defaults: {
        ease: 'none'
      }
    });
    
    tl.to(
      SELECTOR.BG, {
        opacity: 1,
        duration: 0.3,
      })
      .to(
        SELECTOR.BODY, {
          opacity: 1,
          duration: 0.1,
        }, '-=0.5'
      )
      .to(
        SELECTOR.COPY.spans, {
          opacity: 1,
          duration: 0.5,
          stagger: {
            each: 0.1
          },
        }, '-=0.5'
      )
      .to(
        SELECTOR.LOADER, {
          opacity: 0,
          duration: 0.3,
      }, '-=1'
    );
  }

  loaded () {
    SELECTOR.HTML.classList.remove(CLASSES.LOCKED);
    SELECTOR.HTML.classList.add(CLASSES.LOADED);
  }
}
